import axios from 'axios';

import { SignInResultDto } from '@tallo/auth';

import {
  AcceptTeamInviteWithCredentialsDto,
  AcceptTeamInviteWithGoogleDto,
  TeamInviteDetailsDto,
} from '../interfaces/team-invite.dto';

/** The public half of invites: what the emailed link opens, before there is a session */
class TeamInviteService {
  async getDetails(token: string): Promise<TeamInviteDetailsDto> {
    return (await axios.get<TeamInviteDetailsDto>(`auth/team-invite/${token}`)).data;
  }

  async acceptWithCredentials(dto: AcceptTeamInviteWithCredentialsDto): Promise<SignInResultDto> {
    return (await axios.post<SignInResultDto>('auth/accept-team-invite-creds', dto)).data;
  }

  async acceptWithGoogle(dto: AcceptTeamInviteWithGoogleDto): Promise<SignInResultDto> {
    return (await axios.post<SignInResultDto>('auth/accept-team-invite-google', dto)).data;
  }
}

export default new TeamInviteService();
